import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { DoughnutChartItem } from '../doughnut-chart/dought-item';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
@Component({
  selector: 'app-doughnut-chartjs',
  templateUrl: './doughnut-chartjs.component.html',
  styleUrls: ['./doughnut-chartjs.component.css'],
})
export class DoughnutChartjsComponent implements OnInit, OnChanges {
  chart: Chart;
  @ViewChild('chart')
  chartRef: ElementRef;

  @Input()
  items: Array<DoughnutChartItem> = [
    // {name: 'Orange', count: 50, color: 'orange'},
    // {name: 'Apple', count: 25, color: 'red'},
    // {name: 'Pear', count: 15, color: 'green'}
  ];

  @Input() labels= {};
  @Input() hideTable = false;
  @Input() hideAmount = false;
  @Input() hideReturns = true;

  private _total = 0;
  constructor() {}
  makeid() {
    var text = '';
    var possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  ngOnInit() {
    this.processData();    
  }
  destroy(){
    if(this.chart) {
      this.chart.update();
    }
  }
  processData(){
    const values = this.items.map((item) => item.count);
    const colors = this.items.map((item) => item.color);
    const labels = this.items.map((item) => item.name);
    const data = {
      datasets: [
        {
          data: values,
          backgroundColor: colors,
        },
      ],
      // These labels appear in the legend and in the tooltips when hovering different arcs
      labels: labels,
    };
    this.chart = new Chart(this.chartRef.nativeElement, {
      type: 'doughnut',
      data: data,
      options: {
        legend: {
          display: false,
        },
      },
    });

    if (this.items.length > 0) {
      this._total = this.items.map((a) => a.count).reduce((x, y) => x + y);
    }
  }

  ngOnChanges() {
    if (this.items.length > 0) {
      this._total = this.items.map((a) => a.count).reduce((x, y) => x + y);
    }
    this.processData();
    this.destroy();
  }

  getPerimeter(radius: number): number {
    return Math.PI * 2 * radius;
  }

  getColor(index: number): string {
    return this.items[index].color;
  }

  getOffset(radius: number, index: number): number {
    let percent = 0;
    for (let i = 0; i < index; i++) {
      percent += this.items[i].count / this._total;
    }
    const perimeter = Math.PI * 2 * radius;
    return perimeter * percent;
  }
  getPercentageForItem(item) {
    // if(item.showAmounts){
    //   console.log(console.log(item.name, this._total, item.count));
    // }
    return Math.round((item.count / this._total) * 100) || 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/doughnut-chartjs/doughnut-chartjs.component.ts